/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { StyledTableLoading } from './tableLoadingStyles';
import { EmbersLoading } from '../../../loading/loading';
export var EmbersTableLoading = function EmbersTableLoading() {
  return /*#__PURE__*/React.createElement(StyledTableLoading, {
    className: "EmbersTableLoading-root"
  }, /*#__PURE__*/React.createElement(EmbersLoading, {
    size: 72
  }));
};